<template>
    <b-navbar
        toggleable="lg"
        type="dark"
        variant="primary"
    >
        <router-link to="/">
            <b-navbar-brand class="logo" href="/">
                <div
                    class="brand-wrapper"
                    @mouseenter="onBrandHover(true)"
                    @mouseleave="onBrandHover(false)"
                >
                    <BImg
                        class="brand-no-hover ml-3"
                        width="48px"
                        src="https://banedev.s3.us-east-2.amazonaws.com/Portfolio/BaneDevSilver.png"
                    />

                    <BImg
                        class="brand-hover ml-3 mt-n2 mb-n1"
                        width="55px"
                        src="https://banedev.s3.us-east-2.amazonaws.com/Portfolio/BaneDevGold.png"
                    />
                </div>
            </b-navbar-brand>
        </router-link>

        <p class="version" :class="{ 'version-gold': brandHover }">v{{version}}</p>

        <b-navbar-toggle target="nav-collapse"/>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
                <router-link
                    class="routerLink"
                    to="/"
                >
                    <b-nav-item href="/">Home</b-nav-item>
                </router-link>

                <router-link
                    class="routerLink"
                    to="/about"
                >
                    <b-nav-item href="/about">About</b-nav-item>
                </router-link>

                <BNavItemDropdown
                    text="Projects"
                    right
                >
                    <b-dropdown-item
                        class="routerLink"
                        @click="navigate('Zauvu')"
                    >
                        <FontAwesomeIcon :icon="[ 'fas', 'plane' ]" class="mr-3 mr-lg-1"/>
                        Zauvu
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="routerLink"
                        @click="navigate('September Thomas')"
                    >
                        <FontAwesomeIcon :icon="[ 'fas', 'book' ]" class="mr-3 mr-lg-1"/>
                        September Thomas
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="routerLink"
                        @click="navigate('Quick Buck')"
                    >
                        <FontAwesomeIcon :icon="[ 'fas', 'money-bill-wave' ]" class="mr-3 mr-lg-1"/>
                        Quick Buck
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="routerLink"
                        @click="navigate('Bane Lib')"
                    >
                        <FontAwesomeIcon :icon="[ 'fas', 'code' ]" class="mr-3 mr-lg-1"/>
                        Bane Lib
                    </b-dropdown-item>
                </BNavItemDropdown>

                <b-navbar-nav class="socials">
                    <b-nav-item
                        @click="$emit('openModal')"
                    >
                        <FontAwesomeIcon :icon="[ 'fas', 'id-badge' ]" class="mr-3 mr-lg-0 fa-2x"/>
                    </b-nav-item>

                    <b-nav-item
                        href="https://www.linkedin.com/in/david-bane-79a959129/"
                        target="_blank"
                    >
                        <FontAwesomeIcon :icon="[ 'fab', 'linkedin' ]" class="mr-3 mr-lg-0 fa-2x"/>
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    import pkg from '../../package.json'

    import {library} from '@fortawesome/fontawesome-svg-core';

    import {
        faLinkedin
    } from '@fortawesome/free-brands-svg-icons';

    import {
        faBook,
        faCode,
        faIdBadge,
        faMoneyBillWave,
        faPlane,
    } from '@fortawesome/free-solid-svg-icons';

    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    import Vue from "vue";

    library.add(
        faBook,
        faCode,
        faIdBadge,
        faLinkedin,
        faMoneyBillWave,
        faPlane,
    );

    Vue.component('FontAwesomeIcon', FontAwesomeIcon);

    export default {
        name: 'NavBar',
        data() {
            return {
                version: pkg.version,
                brandHover: false,
            }
        },
        methods: {
            onBrandHover(flag) {
                this.brandHover = flag;
            },
            async navigate(routeName) {
                await this.$router.push({name: routeName});
            },
        }
    }
</script>

<style
    scoped
    lang="sass"
>
    @import "../custom"

    a
        text-decoration: none

    .routerLink
        text-decoration: none

    .socials
        flex-direction: row !important

    .logo
        display: inline-block
        &:hover
            .brand-hover
                display: inline-block
                margin-bottom: 2px
            .brand-no-hover
                display: none
        .brand-hover
            display: none
    .version
        color: $primary-grey
        transition: color 160ms ease, opacity 160ms ease
        &.version-gold
            color: $primary-gold
        opacity: 0.8
        font-weight: 500

    .routerLink
        text-decoration: none !important
        &:hover
            opacity: 0.85

    /* Navbar polish: sticky + subtle glass effect */
    .navbar
        position: sticky
        top: 0
        margin: 10px 12px
        border-radius: 12px
        box-shadow: 0 6px 16px rgba(15,23,42,0.12)
        background-color: rgba(44, 103, 0, 0.85) !important
        backdrop-filter: saturate(180%) blur(12px)
        -webkit-backdrop-filter: saturate(180%) blur(12px)
        z-index: $zindex-sticky

    /* Dropdown alignment: glassy menu + no blue outline */
    ::v-deep .dropdown-menu
        background-color: rgba(44, 103, 0, 0.94) !important
        border: 1px solid rgba(255, 255, 255, 0.08)
        backdrop-filter: saturate(180%) blur(8px)
        -webkit-backdrop-filter: saturate(180%) blur(8px)
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18)
        border-radius: 12px
        overflow: hidden
        &:focus, &:focus-visible
            outline: none
            box-shadow: none

    ::v-deep .dropdown-item
        color: #eaf2e3
        transition: background-color 120ms ease, color 120ms ease
        &:hover
            background-color: rgba(255, 255, 255, 0.06)
            color: #ffffff
        &:focus
            outline: none
            box-shadow: none
            background-color: rgba(255, 255, 255, 0.08)

    ::v-deep .nav-link.dropdown-toggle
        &:focus
            outline: none
            box-shadow: none
</style>
